import { render, staticRenderFns } from "./prod-carousel.vue?vue&type=template&id=7b43ca40&scoped=true"
import script from "./prod-carousel.vue?vue&type=script&lang=js"
export * from "./prod-carousel.vue?vue&type=script&lang=js"
import style0 from "./prod-carousel.vue?vue&type=style&index=0&id=7b43ca40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b43ca40",
  null
  
)

export default component.exports